import React from 'react'
import '../Styles/style.css'


const ErrorInfoComp = (props) => {

    return(
        <div id="error_text" className="error-text">
            {props.errorMsg}
        </div>   
    )
}

export default ErrorInfoComp;